import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const avatarUrlResolver: FieldResolver = (metadata: Metadata) =>
  ({ avatarUrl: metadata.getAvatarUrl() } as StreamData)

export default avatarUrlResolver
